export const dealState = {
  accepted: "accepted",
  requested: "requested",
};
